import { computed, reactive, type ComputedRef, type UnwrapNestedRefs } from 'vue';
import type { MoviePlayerState } from 'src/models/moviePlayer';
import { useAuth } from 'src/composables/useAuth';
import { openNewInfraDoctorTab } from 'src/lib/moviePlayerHelper';

interface MoviePlayerInfraDoctorContext {
  ifdLink: ComputedRef<string | undefined>;
  openInfraDoctor: () => void;
}

export function useMoviePlayerInfraDoctor(
  state: UnwrapNestedRefs<MoviePlayerState>,
): UnwrapNestedRefs<MoviePlayerInfraDoctorContext> {
  const { user } = useAuth();
  const ifdLink = computed(() => user?.settings.ifdLink);

  const openInfraDoctor = () => {
    const ifdLinkPrefix = ifdLink.value;
    if (!state.movieList.current.isCurrentMovieReady ||
        !ifdLinkPrefix ||
        !state.movieList.current.currentMovie ||
        !state.movieList.listSelection.currentMovieList ||
        !state.geo.currentMgi) { return; }
    const params = {
      ifdLinkPrefix,
      currentMovieList: state.movieList.listSelection.currentMovieList,
      currentMovie: state.movieList.current.currentMovie,
      currentMovieIdx: state.movieList.current.currentMovieIdx,
      currentMgi: state.geo.currentMgi,
      currentMgiIdx: state.geo.currentMgiIdx,
      isFirstMovie: state.movieList.current.isFirstMovie,
      isLastMovie: state.movieList.current.isLastMovie,
    };
    openNewInfraDoctorTab(params);
  };

  return reactive({
    ifdLink,
    openInfraDoctor,
  });
}
